import React from 'react'
import '../../App.css'
import PageHeader from '../../Components/Instructor_Dashboard/PageHeader'
import { Row,Col } from 'antd'
import CommonTable from '../../Components/CommonTable'
import { Select } from 'antd';
import SelectInput from '../../UI/SelectInput'

const columns = [
  {
    title: '#',
    dataIndex: 'index',
    key: 'index',
    render: (text, record, index) => index + 1,  
  },
  {
    title: 'Title',
    dataIndex: 'title',
    key: 'title',
    sorter: (a, b) => a.title.localeCompare(b.title), 
  },
  {
    title: 'Category',
    dataIndex: 'category',
    key: 'category',
    sorter: (a, b) => a.category.localeCompare(b.category), 
  },
];

const data = [
  {
    key: '1',
    title: 'John Brown',
    category: 'Web Development', // Add category field
  },
  {
    key: '2',
    title: 'Jim Green',
    category: 'Design', // Add category field
  },
];

const categoryOptions = [
  {
    label: <span>manager</span>,
    title: 'manager',
    options: [
      {
        label: <span>Jack</span>,
        value: 'Jack',
      },
      {
        label: <span>Lucy</span>,
        value: 'Lucy',
      },
    ],
  },
  {
    label: <span>engineer</span>,
    title: 'engineer',
    options: [
      {
        label: <span>Chloe</span>,
        value: 'Chloe',
      },
      {
        label: <span>Lucas</span>,
        value: 'Lucas',
      },
    ],
  },
]

const statusOptions =  [
  {
    label: <span>manager</span>,
    title: 'manager',
    options: [
      {
        label: <span>Jack</span>,
        value: 'Jack',
      },
      {
        label: <span>Lucy</span>,
        value: 'Lucy',
      },
    ],
  },
  {
    label: <span>engineer</span>,
    title: 'engineer',
    options: [
      {
        label: <span>Chloe</span>,
        value: 'Chloe',
      },
      {
        label: <span>Lucas</span>,
        value: 'Lucas',
      },
    ],
  },
]

const priceOptions = [
  {
    label: <span>manager</span>,
    title: 'manager',
    options: [
      {
        label: <span>Jack</span>,
        value: 'Jack',
      },
      {
        label: <span>Lucy</span>,
        value: 'Lucy',
      },
    ],
  },
  {
    label: <span>engineer</span>,
    title: 'engineer',
    options: [
      {
        label: <span>Chloe</span>,
        value: 'Chloe',
      },
      {
        label: <span>Lucas</span>,
        value: 'Lucas',
      },
    ],
  },
]

const Course_Manager = () => {

  return (
    <div className='courses_page'>
       <PageHeader title={'Courses'} btnName={'Add new course'} link={'/user/add_course'}/>

       <Row className='dashboard_cards_div'>
         
         <Col className='courses_card'>
             <h1>5</h1>
             <p className='light_grey'>Active courses</p>
         </Col>

         <Col className='courses_card'>
             <h1>5</h1>
             <p className='light_grey'>Pending courses</p>
         </Col>

         <Col className='courses_card'>
             <h1>5</h1>
             <p className='light_grey'>Draft courses</p>
         </Col>

         <Col className='courses_card'>
             <h1>54</h1>
             <p className='light_grey'>Free courses</p>
         </Col>

         <Col className='courses_card'>
             <h1>54</h1>
             <p className='light_grey'>Paid courses</p>
         </Col>
         
       </Row>

       <div className='course_manager_div'>
         <h4>Course List</h4>

         <div className='course_manager_select_btn_div'>
            <div>
              <p>Categories</p>
              <SelectInput placeholder={'Category'} options={categoryOptions}
               classname={'course_select_box'}
              />
            </div>

            <div>
              <p>Status</p>
              <SelectInput placeholder={'Status'} options={statusOptions}
               classname={'course_select_box'}
              />
            </div>

            <div>
              <p>Price</p>
              <SelectInput placeholder={'Price'} options={priceOptions}
               classname={'course_select_box'}
              />
            </div>

            <div>
              <button className='course_manager_filter_btn'>Filter</button>
            </div>
         </div>

          <div>
              <CommonTable columns={columns} data={data}/>
          </div>
       </div>
    </div>
  )
}

export default Course_Manager
